export const GAMEPLAY_OVERLAYS = [
  'Hud',
  'CompanionLayer',
  'QuestLayer',
  'PhoneOverlay',
  'Reward',
] as const;

const PRE_WORLD_SCENES = new Set(['Onboarding', 'Fortune', 'Splash', 'Boot', 'Preload']);

export type OverlayPolicy = {
  questOfferVisible: boolean;
  stop: string[];
};

/** Jedna polityka życia overlayów dla wszystkich przejść między scenami. */
export function overlayPolicyFor(target: string): OverlayPolicy {
  if (PRE_WORLD_SCENES.has(target)) {
    return {
      questOfferVisible: false,
      stop: [...GAMEPLAY_OVERLAYS],
    };
  }

  const stop = ['PhoneOverlay', 'Reward'].filter((key) => key !== target);
  return {
    questOfferVisible: target === 'Town',
    stop,
  };
}
